/**
 * CONSTANTS PLACEHOLDER FOR URLS.
 * ANY NEW URL SHOULD BE ADDED HERE AS A CONSTANT AND
 * REFERENCED IN THE APPLICATION WHEREVER REQUIRED.
 * @type {string}
 */

const veritas = `/veritas`;
const support = `/support`;
const billing = `/billing`;
const configTool = `https://lseg-config.globaldataconsortium.com/wvconfig`;
export const HOME = `/home`;

export const VERITAS = {
    home: veritas,
    kyc: veritas + `/kyc-services/`,
    kyc_detail: veritas + `/kyc-services/:serviceID`,
    kyb: veritas + `/kyb-services/`,
    kyb_detail: veritas + `/kyb-services/:serviceID`,
    data_providers: veritas + `/data-providers/`,
    data_sources: veritas + `/data-source/`,
    dp_detail: veritas + `/data-providers/:providerID`,
    data_source_detail: veritas + `/data-source/:resourceType/:sourceID`,
    kyb_source_detail: veritas + `/data-source/:resourceType/:sourceID`,
    country_coverage: veritas + `/country-coverage/`,
    country_detail: veritas + '/country-coverage/:countryID',
    billing_groups: veritas + `/billing-groups/`,
    billing_group_detail: veritas + `/billing-groups/:billingGroupID`,
}

export const SUPPORT = {
    home: support,
    tx_debug: support + `/tx-debug-logs`,
    testcache: support + `/kyc-testcache`,
    kyb_testcache: support + `/kyb-testcache`,
}

export const BILLING = {
    home: billing,
    organizations: billing + `/organizations/`,
    organization_detail: billing + `/organizations/:orgID`,
    pricing_tables_v2: billing + `/v2/pricing-tables/`,
    pricing_tables_details_v2: billing + `/v2/pricing-tables/:pricingID`,
    manual_entry_records: billing + '/manual-entry-records/',
    billing_reports: billing + '/reports/',
}

export const CONFIG_TOOL = {
    home: configTool,
    routeToTenantDetail: configTool + `/tenants/gdcproperties/?tenantid=`,
    routeToConfigDetail: configTool + `/configs/config?id=`,
    configDetailParams: `&parent_type=config&parentid=`,
}

export const LOGOUT = `/logout`;

const exports = {
    HOME,
    VERITAS,
    SUPPORT,
    BILLING,
    CONFIG_TOOL,
    LOGOUT,
}

export default exports;
